import axios from 'axios';
import Logger from '@/utils/Logger.js';
import Settings from '@/Settings.js';

const API_URL = Settings.API_URL + "/api/v1";
const GOOGLE_GEOCODE_URL = "https://maps.googleapis.com/maps/api/geocode/json";

const uri = (part) => `${API_URL}${part}`;

let ajaxErrorHandler = (...msg) => {
	Logger.error(...msg);
}

class Ajax {
	
	static setHandlers ({ errorHandler = null } = {}) {
		ajaxErrorHandler = errorHandler;
	}
	
	static toData (resp) {
		let data = resp.data;
		return data;
	}
	
	static get (...params) {
		return Ajax.action('get', ...params);
	}
	static post (...params) {
		return Ajax.action('post', ...params);
	}
	
	static async action (name, ...params) {
		try {
			let resp = await axios[name](...params);
			let status = resp.status;
			if (status === 500) {
				
			}
			if (status === 502) {
				
			}
			return [null, Ajax.toData(resp)];
		} catch (err) {
			if (err.message === 'Network Error') {
				Logger.error('Server is not available now. Server is under maintenance or network connection lost');
				ajaxErrorHandler('Server is under maintenance or network connection lost', { duration: 0 });
			}
			return [err, null];
		}
	}
	
	static async getSpot (ouid) {
		return Ajax.get(uri(`/public/spots/${ouid}`), {});
	}
	
	static async getSpotByLabel (x) {
		console.log(`/public/label/${x}`);
		return Ajax.get(uri(`/public/label/${x}`), {});
	}
	
	static async getSpotsAround ({ position, zoomLevel, radius }) {
		return Ajax.get(uri('/public/search'), {
			params: {
				lat:  position.latitude,
				lon:  position.longitude,
				zoom: zoomLevel,
				r:    radius
			}
		});
	}
	
	static async getPlacesAutocompletion (address) {
		return Ajax.get(GOOGLE_GEOCODE_URL, {
			params: {
				address,
				key: Settings.GOOGLE_MAPS_API_KEY
			}
		});
	}
	
	static async createJob ({ emailFrom, emailTo, text, amount, name }) {
		return Ajax.post(uri('/public/jobs'), arguments[0]);
	}
	
	static async uploadFile (juid, id, file, cb) {
		let formData = new FormData();
		formData.append("page", file);
		formData.set('filename', file.name);
		let resp = await axios.post(uri(`/public/uploads/${juid}/${id}`), formData, {
			headers: {
				'Content-Type': 'multipart/form-data'
			},
			onUploadProgress: function (progressEvent) {
				cb(Math.round((progressEvent.loaded * 100) / progressEvent.total));
			}
		});
		console.log(resp);
		return true;
	}
	
}

export default Ajax;
















